// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"206":"656effba488a8d92","888":"06e90e57a05f1d61"}[chunkId] + ".css";
};